import {Component} from '@angular/core';

@Component({
  selector: 'em-auth-background',
  templateUrl: './auth-background.component.html',
})
export class AuthBackgroundComponent {}
